import { gsap } from "../layout"

// custom library
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

function testimonialsSwiper() {
    const swiper = new Swiper('.testimonials__swiper', {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 32,
            }
        },
        navigation: {
            nextEl: '.testimonials .swiper-button-next',
            prevEl: '.testimonials .swiper-button-prev',
        },
        pagination: {
            el: '.testimonials .swiper-pagination',
            type: 'bullets',
            dynamicBullets: true,
        },
    });
}

function testimonialsCursor() {
    const cursor = document.querySelector('.cursor')

    cursor.innerHTML = '<div class="testimonials__cursor"><span>Swipe</span><svg width="28" height="12" viewBox="0 0 28 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.375 4.125L1.5 6M1.5 6L3.375 7.875M1.5 6H10.5" stroke="#EAE5DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.625 4.125L26.5 6M26.5 6L24.625 7.875M26.5 6H17.5" stroke="#EAE5DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'

    function onMouseMove(e) {
        gsap.to('.cursor', {
            top: e.clientY,
            left: e.clientX,
            duration: 0.9,
            ease: 'expo.out',
        })
    }

    const hoverArea = document.querySelector('.testimonials__swiper')

    if (!hoverArea) return

    hoverArea.addEventListener('mouseenter', () => {

        gsap.to('.cursor', {
            autoAlpha: 1,
        })
    })

    hoverArea.addEventListener('mouseleave', () => {
        gsap.to('.cursor', {
            autoAlpha: 0,
        })
    })

    document.body.addEventListener('mousemove', (e) => {
        onMouseMove(e)
    })
}

function blogSwiper() {
    function vwToPxUnits(vw, viewport) {
        return vw * viewport / 100
    }

    const swiper = new Swiper('.blog__swiper', {
        modules: [Autoplay, Pagination, Navigation],
        slidesPerView: 1,
        speed: 800,
        spaceBetween: 20,
        loop: true,
        autoplay: {
            delay: 4000,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: vwToPxUnits(5.208, window.innerWidth),
            }
        },
        navigation: {
            nextEl: '.blog .swiper-button-next',
            prevEl: '.blog .swiper-button-prev',
        },
        pagination: {
            el: '.blog .swiper-pagination',
            type: 'bullets',
            dynamicBullets: true,
        },
    });
}

document.addEventListener('DOMContentLoaded', () => {
    testimonialsSwiper()
    testimonialsCursor()
    blogSwiper()
})